<template>
  <section class="container">
    <div class="btn-group">
      <el-button
        type="primary"
        class="add-btn"
        @click="toAdd">新增</el-button>
    </div>

    <table-pagination
      :config="config"
      :datasource="datasource"
      @change-page="handlerPageChange">
      <!-- <el-table-column sl></el-table-column> -->
      <el-table-column
        slot="filter"
        label="图片"
        align="center">
        <template slot-scope="scope">
          <img
            :src="qiniuDomain + scope.row.brand_img"
            style="max-width: 150px; max-height:100px;">
        </template>
      </el-table-column>
      <el-table-column
        slot="action"
        fixed="right"
        label="操作"
        width="285"
        align="center">
        <template slot-scope="scope">
          <div>
            <el-button
              type="success"
              plain
              @click="toDetail(scope.row.uuid)">详情</el-button>
            <el-button
              type="primary"
              plain
              @click="toEdit(scope.row.uuid)">编辑</el-button>
            <el-button
              type="danger"
              plain
              @click="handlerDel(scope)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </table-pagination>

  </section>
</template>

<script>
import TablePagination from '@/components/table-pagination';
// import Mixin from '@/mixins/get-qiniu'
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
import {
  brandList, addBrand, editBrand, delBrand, styleList,
} from '@/api/style'

export default {
  data() {
    return {
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
      dialogEdit: false,
      dialogType: 0, //  0-新增、1-编辑
      editObject: { //  根据接口来的命名，不是很喜欢---
        brand_title: '',
        brand_english_title: '',
        brand_img: '',
        style_uuid: '',
        brand_url: '',
        brand_content: '',
        brand_file: '',
        brand_banner: '',
        //  编辑时用
        style_title: '',
        uuid: '',
      },
      config: {
        // pagination: true,
        size: 5,
        fields: [
          {
            prop: 'brand_title',
            label: '标题',
          },
          {
            prop: 'brand_english_title',
            label: '英文标题',
          },
          {
            prop: 'brand_url',
            label: '跳转链接',
          },
          {
            prop: 'style_title',
            label: '所属风格',
          },
        ],
      },
      datasource: {
        total: 1,
        data: [],
      },
      pageIndex: 1,
    };
  },

  components: {
    TablePagination,
  },

  created() {
    this.network().getQiniuInfo()
    this.network().brandList()
  },
  methods: {
    //  额，凑活用了，三个可以合成一个的,勿怪--
    toAdd() {
      this.$router.push({
        path: '/brand-add',
      })
    },
    toDetail(uuid) {
      this.$router.push({
        path: `/brand-detail/${uuid}`,
      })
    },
    toEdit(uuid) {
      this.$router.push({
        path: `/brand-edit/${uuid}`,
      })
    },
    // eslint-disable-next-line no-unused-vars
    handlerPageChange(data) {
      this.pageIndex = data.page
      this.network().brandList()
    },
    handlerEdit(data) {
      this.dialogType = 1 // 编辑框
      this.editObject.style_title = data.row.style_title
      this.editObject.brand_title = data.row.brand_title
      this.editObject.brand_english_title = data.row.brand_english_title
      this.editObject.brand_img = data.row.brand_img
      this.editObject.style_uuid = data.row.style_uuid
      this.editObject.brand_url = data.row.brand_url
      this.editObject.brand_content = data.row.brand_content
      this.editObject.brand_file = data.row.brand_file
      this.editObject.brand_banner = data.row.brand_banner
      this.editObject.style_title = data.row.style_title
      this.editObject.uuid = data.row.uuid
      this.dialogEdit = true
    },
    handlerDel(data) {
      this.network().delBrand(data.row.uuid)
    },
    openAddDialog() {
      this.dialogType = 0
      this.editObject.style_title = ''
      this.editObject.brand_title = ''
      this.editObject.brand_english_title = ''
      this.editObject.brand_img = ''
      this.editObject.style_uuid = ''
      this.editObject.brand_url = ''
      this.editObject.brand_content = ''
      this.editObject.brand_file = ''
      this.editObject.brand_banner = ''
      this.editObject.style_title = ''
      this.editObject.uuid = ''
      this.dialogEdit = true
    },
    handlerNavigator(scope) {
      this.$router.push({
        path: `/example-management/example-${scope.row.alias}`,
      });
    },
    uploadSuccess(res) {
      this.editObject.brand_img = res.hash
    },
    uploadBannerSuccess(res) {
      this.editObject.brand_banner = res.hash
    },
    event() {
      return {
        onSaveClick: () => {
          //  dialogType: 0-新增、1-编辑
          if (this.dialogType === 0) {
            this.network().addBrand()
          } else {
            this.network().editBrand()
          }
        },
      }
    },
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        brandList: async () => {
          const { status, data } = await brandList({
            page_index: this.pageIndex,
            page_count: this.config.size,
          })
          if (status === 200) {
            this.datasource.total = data.data_count
            this.datasource.data = data.char
          }
        },
        addBrand: async () => {
          const { status } = await addBrand(this.editObject)
          if (status === 200) {
            this.dialogEdit = false
            this.network().brandList()
          }
        },
        editBrand: async () => {
          const { status } = await editBrand(this.editObject)
          if (status === 200) {
            this.dialogEdit = false
            this.network().brandeList()
          }
        },
        delBrand: async (uuid) => {
          const { status } = await delBrand({
            uuid,
          })
          if (status === 200) {
            this.dialogEdit = false
            this.network().brandList()
          }
        },
        styleList: async () => {
          const { status, data } = await styleList({
            page_index: 1,
            page_count: 999,
          })
          if (status === 200) {
            this.styleList = data.char
          }
        },
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-bottom: 20px;
  text-align: right;
}
.add-btn {
    margin-left: auto;
  }
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
   .banner-box {
    position: relative;
    margin-right: 20px;
    display: inline-block;
    width: 200px;
    height: 100px;
  }
  .banner-box .icon {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 2;
    width: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 20px;
    cursor: pointer;
  }
  .banner-img {
    width: 200px;
    height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/style/brand-list.vue